import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="mandanten-search"
export default class extends Controller {
	static targets = ["input"]
	static values = {
		delay: { type: Number, default: 250 },
		minLength: { type: Number, default: 3 },
	}

	connect() {
		this.timeout = null
		this.lastSubmitted = null
	}

	queueSubmit() {
		const value = (this.inputTarget.value || "").trim()

		// Wenn weniger als minLength: nur dann submitten, wenn Feld leer ist (Reset)
		if (value.length > 0 && value.length < this.minLengthValue) return

		// Doppelte Submits vermeiden (z.B. wenn Turbo/Reload wieder triggert)
		if (value === this.lastSubmitted) return

		clearTimeout(this.timeout)
		this.timeout = setTimeout(() => {
			this.lastSubmitted = value
			this.element.requestSubmit()
		}, this.delayValue)
	}
}
